import { ContentFilters, ContentTopBar } from 'components';
import { useState } from 'react';
import { CompanyType } from 'types';

import { TicketSelectionFilterForm } from '../ticket-selection-filter-form/ticket-selection-filter-form';
import { TicketSelFilterFormValues } from '../ticket-selection-filter-form/type';

type TicketTopBarProps = {
  getInitialFilterValues: TicketSelFilterFormValues;
  handleFilter: (values: TicketSelFilterFormValues) => void;
};

export const TicketSelectionTopBar = ({
  getInitialFilterValues,
  handleFilter,
}: TicketTopBarProps) => {
  useState<CompanyType>();

  const formId = 'ticket-selection-filters-form';

  return (

    <>
      <ContentTopBar
        title={'Tickets List'}

      />

      <ContentFilters formId={formId}>
        <TicketSelectionFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
